import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withTheme } from '@material-ui/core';
import { ContainerLayout, SubMenu } from 'data/components';
import { Toastr } from 'data/common';
import SubMenuData from '../common/subMenuData';
import { initEnvironment, disconnectEnvironment } from '../actions';

class Layout extends PureComponent {
    static propTypes = {
        initEnvironment: PropTypes.func.isRequired,
        disconnectEnvironment: PropTypes.func.isRequired,
        children: PropTypes.object.isRequired,
        environment: PropTypes.string.isRequired,
        profile: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: null
        };
    }

    componentDidMount() {
        const { profile, history } = this.props;
        if (!profile.get('admin') && !(profile.get('environments') && profile.get('environments').indexOf('fhe') !== -1)) {
            Toastr.error(Translator.translate('error.message.envForbidden'));
            return history.replace('/menu');
        }
        this.initEnv();
    }

    componentWillUnmount() {
        const { disconnectEnvironment } = this.props;
        disconnectEnvironment();
    }

    initEnv = () => {
        const { initEnvironment } = this.props;
        this.setState({ loading: true, error: null });

        initEnvironment()
            .then(() => {
                this.setState({ loading: false, error: null });
            })
            .catch(err => {
                this.setState({ error: Translator.translateWithFallback(`api.message.${err.message}`, 'api.message.default'), loading: false });
            });
    };

    render() {
        const { loading, error } = this.state;
        const { children, environment, profile } = this.props;
        const userRights = profile.getIn(['user_rights', environment], []);
        let tabList = {};
        if (!profile.get('admin') && userRights) {
            tabList = SubMenuData.filter(k => {
                return userRights.indexOf(k.right) !== -1;
            });
        } else {
            tabList = SubMenuData;
        }

        return (
            <div className="d-flex flex-fill flex-column">
                <SubMenu environment={environment} tabList={tabList} />
                <ContainerLayout loading={loading} error={error} onClickFunc={this.initEnv}>
                    {children}
                </ContainerLayout>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        profile: state.data.user
    };
}

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators(Object.assign({}, { initEnvironment, disconnectEnvironment }), dispatch)
    )(withTheme(Layout))
);



// WEBPACK FOOTER //
// ./environments/fhe/layouts/index.js